import Wrapper from "../components/Wrapper"

function PageNotFound() {
    return (
        <div>
            <Wrapper title={ "Page Not Found" }>
            <div>
                <p>404: Not found</p>
            </div>
            </Wrapper>
        </div>
    )
}

export default PageNotFound;